import React, { useState, useContext } from "react";

import Checkbox from "core/Checkbox";
import UploadsGrid from "core/UploadsGrid";
import TruncateText from "core/TruncateText";
import ProcessingScreen from "./ProcessingScreen";
import GridFooterContent from "./GridFooterContent";

import { ContentContainer, AssetContainer } from "core/UploadsGrid/styles";
import {
    Fieldset,
    SelectedCheckboxContainer,
    HoverBodyText,
    FilePreviewContainer,
    Image
} from "./styles";

import { convertPxToRem } from "frontend/components/helpers";

import DropzoneContext from "./context";

const ItemContent = ({
    hasAcceptedFiles,
    file,
    initiallySelected = false,
    index
}) => {
    const [isHovered, setHovered] = useState(false);
    const [isSelected, setSelected] = useState(initiallySelected);
    const [isImageProcessing, setImageProcessing] = useState(true);

    const checkboxValue = isSelected ? `${file.name} is selected` : file.name;

    const hasError = file.errors && file.errors.message;
    const hasWarning = file.warnings && file.warnings.message;
    const hasSuccess =
        file.errors &&
        !file.errors.message &&
        file.warnings &&
        !file.warnings.message;

    const handleCheckboxClick = () => {
        setSelected(!isSelected);
    };

    const handleMouseEnter = () => {
        setHovered(true);
    };

    const handleMouseLeave = () => {
        setHovered(false);
    };

    const handleImageOnLoad = () => {
        setImageProcessing(false);
    };

    return (
        <FilePreviewContainer isImageProcessing={isImageProcessing}>
            <ContentContainer>
                <AssetContainer
                    onMouseEnter={handleMouseEnter} // for mouse
                    onMouseLeave={handleMouseLeave} // for mouse
                    onFocus={handleMouseEnter} // for keyboard
                    onBlur={handleMouseLeave} // for keyboard
                >
                    <SelectedCheckboxContainer
                        isSelected={isSelected}
                        isHovered={isHovered}
                        hasError={hasError}
                        hasWarning={hasWarning}
                        hasSuccess={hasSuccess}
                        title={file.name} // fileName shows on mouse hover due to truncation in UI
                    >
                        <Checkbox
                            ariaLabel={file.name}
                            label=""
                            initialValue={isSelected}
                            value={checkboxValue}
                            onClick={handleCheckboxClick}
                            isDisabled={false}
                        />

                        <HoverBodyText size="xs" type="div">
                            {index + 1} of {hasAcceptedFiles.length}
                        </HoverBodyText>

                        <HoverBodyText size="xs" type="div">
                            <TruncateText charLimit={15}>
                                {file.name}
                            </TruncateText>
                        </HoverBodyText>
                    </SelectedCheckboxContainer>

                    {isImageProcessing && <ProcessingScreen />}

                    <Image
                        data-testid={`added-file-image-${index}`}
                        src={file.preview}
                        alt={`File name ${file.name}`}
                        onLoad={handleImageOnLoad}
                    />
                </AssetContainer>

                {!isImageProcessing && (
                    <GridFooterContent
                        file={file}
                        hasError={hasError}
                        hasWarning={hasWarning}
                        hasSuccess={hasSuccess}
                    />
                )}
            </ContentContainer>
        </FilePreviewContainer>
    );
};

const AddedFiles = () => {
    const { hasAcceptedFiles } = useContext(DropzoneContext);

    // if no files in array, return nothing:
    if (hasAcceptedFiles.length === 0) return null;

    const getContent = hasAcceptedFiles.map((file, index) => {
        return (
            <ItemContent
                key={index}
                file={file}
                index={index}
                initiallySelected={false}
                hasAcceptedFiles={hasAcceptedFiles}
            />
        );
    });

    return (
        <Fieldset aria-label="Uploaded images">
            <UploadsGrid
                numberOfColumns={5}
                gridSpacingSize={convertPxToRem({ px: 24 })}
                gridItemContent={getContent}
            />
        </Fieldset>
    );
};

export default AddedFiles;
